const Illustration2 = (props) => (
  <svg
    width={178}
    height={249}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="#D6FEAE"
      d="m51.736 248.559 125.403-.084-.082-123.095-125.403.084z"
    />
    <path
      d="m51.654 125.893 125.403-.084L35.036 1.569-78 .171 51.654 125.893Z"
      fill="#5171A5"
    />
    <path
      d="M-77.88 107.718 51.736 248.472l.006-123.997-64.89-60.237L-77.952.223l.072 107.495Z"
      fill="#E96D6D"
    />
  </svg>
);

export default Illustration2;
